import "../assets/css/App.css";
import React, { useEffect, useContext } from "react";
import {
  Card,
  Grid,
  Box,
  Button,
  Container,
  TextField,
  Typography,
  CardContent,
  InputLabel
} from "@mui/material";
import logoST from "../assets/images/LogoSTL.svg";
import logoLolify from "../assets/images/Lilofy_color.png";
import { useNavigate } from "react-router-dom";
import { ErrorMessages } from "../app/util/messages";
import {
  validateEmail,
  validateContieneMayusuculas,
  validateContieneNumeros,
  validateContieneCaracteresEspeciales,
} from "../app/util/util";
import InputMask from "react-input-mask";
import { RootStoreContext } from "../app/store/root";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DialogComponent from "../app/common/DialogComponent";
import { observer } from "mobx-react-lite";
import ReCAPTCHA from "react-google-recaptcha";
import { toJS } from "mobx";
import Alerts from "../shared/Alerts";
import { EnumConfiguracion } from "../shared/Enumerables.js";
import LogisticBackdropStore from "../shared/LogisticBackdrop";

function RegisterPage() {
  const rootStore = useContext(RootStoreContext);
  const navigate = useNavigate();
  const captcha = React.useRef(null);

  const { createUsuario } = rootStore.authStore;
  const { getParameter } = rootStore.configuracionStore;

  const initialState = {
    Nombre: undefined,
    ApellidoPaterno: undefined,
    ApellidoMaterno: undefined,
    Correo: undefined,
    Correo2: undefined,
    Celular: undefined,
    CodigoProveedor: undefined,
    Contraseña: null,
    Contraseña2: undefined,
  };
  const [errors, setErrors] = React.useState({
    Nombre: null,
    ApellidoPaterno: null,
    ApellidoMaterno: null,
    Correo: null,
    Correo2: null,
    Celular: null,
    CodigoProveedor: null,
    Contraseña: null,
    Contraseña2: null,
    Captcha: null,
  });
  const [messages, setMessages] = React.useState({
    Nombre: "",
    ApellidoPaterno: "",
    ApellidoMaterno: "",
    Correo: "",
    Correo2: "",
    Celular: "",
    CodigoProveedor: "",
    Contraseña: "",
    Contraseña2: "",
    Captcha: "",
  });

  const [model, setModel] = React.useState(initialState);
  const [longitudMaxima, setLongitudMaxima] = React.useState(undefined);
  const [longitudMinima, setLongitudMinima] = React.useState(undefined);
  const [requiereNumeros, setRequiereNumeros] = React.useState(undefined);
  const [requiereMayusculas, setRequiereMayusculas] = React.useState(undefined);
  const [requiereCaracteresEspeciales, setRequiereCaracteresEspeciales] =
    React.useState(undefined);
  const [showDialogClear, setShowDialogClear] = React.useState(false);
  const [disabledAceptar, setDisabledAceptar] = React.useState(true);
  const [showDialogConfirmar, setShowDialogConfirmar] = React.useState(false);

  useEffect(() => {
    document.title = "Lilofy | Registrarse";
    getParametersInitialForPasswordValidation();
  }, []);

  useEffect(() => {
    if (
      errors.Nombre == false &&
      errors.ApellidoPaterno == false &&
      errors.ApellidoMaterno == false &&
      errors.Correo == false &&
      errors.Correo2 == false &&
      errors.Celular == false &&
      errors.CodigoProveedor == false &&
      errors.Contraseña == false &&
      errors.Contraseña2 == false &&
      errors.Captcha == false
    ) {
      setDisabledAceptar(false);
    } else {
      setDisabledAceptar(true);
    }
  }, [errors]);

  useEffect(() => {
    if (longitudMinima && longitudMaxima)
      ErrorMessages.usuario.ContraseñaLongitud =
        ErrorMessages.usuario.ContraseñaLongitud.replace(
          "{0}",
          longitudMinima?.valor
        ).replace("{1}", longitudMaxima?.valor);
  }, [longitudMinima, longitudMaxima]);

  /** Metodos */
  const setValue = (key, value) => {
    setModel({ ...model, ...{ [key]: value } });
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };

  const onChangeRecaptcha = () => {
    if (captcha.current.getValue()) {
      setError("Captcha", false);
      setMessage("Captcha", "");
    } else {
      rootStore.alertStore.alertError(ErrorMessages.usuario.Captcha)
      setError("Captcha", true);
      setMessage("Captcha", ErrorMessages.usuario.Captcha);
      setModel({
        ...model,
        ... {
          Contraseña: null,
          Contraseña2: undefined
        },
      })
      setErrors({
        ...errors,
        ... {
          Contraseña: true,
          Contraseña2: true
        },
      })
      setMessages({
        ...messages,
        ... {
          Contraseña: ErrorMessages.usuario.ContraseñaRequerida,
          Contraseña2: ErrorMessages.usuario.ContraseñaRequerida
        },
      })
    }
  };

  const validationEmail = (campo, e) => {
    setValue(campo, e.target.value);
    if (e.target.value.length > 0) {
      if (validateEmail(e.target.value)) {
        setError(campo, false);
        setMessage(campo, "");
      } else {
        setError(campo, true);
        setMessage(campo, ErrorMessages.usuario.Correo)
        return
      }
      if ((campo == 'Correo' && model.Correo2?.length > 0) && e.target.value?.toUpperCase() !== model.Correo2?.toUpperCase()) {
        setError(campo, true)
        setMessage(campo, ErrorMessages.usuario.CorreosDiferentes)
      }
      if ((campo == 'Correo2' && model.Correo?.length > 0) && e.target.value?.toUpperCase() !== model.Correo?.toUpperCase()) {
        setError(campo, true)
        setMessage(campo, ErrorMessages.usuario.CorreosDiferentes)
      }
      if ((campo == 'Correo' && model.Correo2?.length > 0 && e.target.value?.toUpperCase() === model.Correo2?.toUpperCase())
        || (campo == 'Correo2' && model.Correo?.length > 0 && e.target.value?.toUpperCase() === model.Correo?.toUpperCase())) {
        setErrors({
          ...errors,
          ...{
            Correo: false,
            Correo2: false
          },
        });
        setMessages({
          ...messages,
          ...{
            Correo: '',
            Correo2: '',
          },
        });
        return
      }
    } else {
      setError(campo, true);
      setMessage(campo, ErrorMessages.usuario.Correo);
    }

  };

  const validationContraseña = (campo, value) => {
    setValue(campo, value)
    if (value.length < parseInt(longitudMinima?.valor ?? 6) || value.length > parseInt(longitudMaxima?.valor ?? 12)) {
      setError(campo, true)
      setMessage(campo, ErrorMessages.usuario.ContraseñaLongitud)
      return
    }

    if ((campo == 'Contraseña' && model.Contraseña2?.length > 0) && value?.toUpperCase() !== model.Contraseña2?.toUpperCase()) {
      setError(campo, true)
      setMessage(campo, ErrorMessages.usuario.ContraseñasDiferentes)
      return
    }
    if ((campo == 'Contraseña2' && model.Contraseña?.length > 0) && value?.toUpperCase() !== model.Contraseña?.toUpperCase()) {
      setError(campo, true)
      setMessage(campo, ErrorMessages.usuario.ContraseñasDiferentes)
      return
    }
    if ((campo == 'Contraseña' && model.Contraseña2?.length > 0 && value?.toUpperCase() === model.Contraseña2?.toUpperCase())
      || (campo == 'Contraseña2' && model.Contraseña?.length > 0 && value?.toUpperCase() === model.Contraseña?.toUpperCase())) {
      setErrors({
        ...errors,
        ...{
          Contraseña: false,
          Contraseña2: false
        },
      });
      setMessages({
        ...messages,
        ...{
          Contraseña: '',
          Contraseña2: '',
        },
      });
      return
    }
    setError(campo, false)
    setMessage(campo, '')
  }

  const clearInitialState = () => {
    initialErrors();
    setModel({ ...initialState });
  };

  const initialErrors = () => {
    setErrors({
      ...errors,
      ...{
        Nombre: true,
        ApellidoPaterno: true,
        ApellidoMaterno: true,
        Correo: true,
        Correo2: true,
        Celular: true,
        CodigoProveedor: true,
        Contraseña: true,
        Contraseña2: true,
      },
    });
    setMessages({
      ...messages,
      ...{
        Nombre: ErrorMessages.usuario.Nombre,
        ApellidoPaterno: ErrorMessages.usuario.ApellidoPaterno,
        ApellidoMaterno: ErrorMessages.usuario.ApellidoMaterno,
        Correo: ErrorMessages.usuario.Correo,
        Correo2: ErrorMessages.usuario.Correo,
        Celular: ErrorMessages.usuario.Celular,
        CodigoProveedor: ErrorMessages.usuario.CodigoProveedor,
        Contraseña: ErrorMessages.usuario.ContraseñaLongitud,
        Contraseña2: ErrorMessages.usuario.ContraseñaLongitud,
      },
    });
  };

  const guardarUsuario = async () => {
    if (validarUsuario()) {
      rootStore.logisticBackdropStore.openLoading();
      await createUsuario(
        parseInt(process.env.REACT_APP_ID_ORGANIZATION),
        model
      ).then(
        (resp) => {
          rootStore.logisticBackdropStore.closeLoading();
          if (resp.success && resp?.data?.exito) {
            rootStore.alertStore.alertCreateSuccess();
            setTimeout(() => {
              navigate("/");
            }, 500);
          } else if (resp?.data?.validations?.length > 0) {
            if (resp.data.validations.length > 0) {
              const Errors = {
                Nombre: false,
                ApellidoPaterno: false,
                ApellidoMaterno: false,
                Correo: false,
                Correo2: false,
                Celular: false,
                CodigoProveedor: false,
                Contraseña: false,
                Contraseña2: false,
                Captcha: false,
              };
              const Mensajes = {
                Correo: "",
                Celular: "",
              };
              resp.data.validations.forEach((element) => {
                if (element.campo.toUpperCase() == "Correo".toUpperCase()) {
                  Errors.Correo = true;
                  Mensajes.Correo = element.mensaje;
                }
                if (element.campo.toUpperCase() == "Celular".toUpperCase()) {
                  Errors.Celular = true;
                  Mensajes.Celular = element.mensaje;
                }
              });
              setErrors({ ...Errors });
              setMessages({ ...Mensajes });
            }
          } else {
            rootStore.alertStore.alertError(resp.responseMessage);
          }
        },
        (err) => {
          rootStore.logisticBackdropStore.closeLoading();
        }
      );
    }
  };

  const validarUsuario = () => {
    const Errors = {
      Nombre: false,
      ApellidoPaterno: false,
      ApellidoMaterno: false,
      Correo: false,
      Correo2: false,
      Celular: false,
      CodigoProveedor: false,
      Contraseña: false,
      Contraseña2: false,
      Captcha: false,
    };
    const Mensajes = {
      Nombre: "",
      ApellidoPaterno: "",
      ApellidoMaterno: "",
      Correo: "",
      Correo2: "",
      Celular: "",
      CodigoProveedor: "",
      Contraseña: "",
      Contraseña2: "",
      Captcha: "",
    };
    if (!model.Nombre || model.Nombre?.length == 0) {
      Errors.Nombre = true;
      Mensajes.Nombre = ErrorMessages.usuario.Nombre;
    }
    if (!model.ApellidoPaterno || model.ApellidoPaterno?.length == 0) {
      Errors.ApellidoPaterno = true;
      Mensajes.ApellidoPaterno = ErrorMessages.usuario.ApellidoPaterno;
    }
    if (!model.ApellidoMaterno || model.ApellidoMaterno?.length == 0) {
      Errors.ApellidoMaterno = true;
      Mensajes.ApellidoMaterno = ErrorMessages.usuario.ApellidoMaterno;
    }
    if (!model.Correo || model.Correo?.length == 0) {
      Errors.Correo = true;
      Mensajes.Correo = ErrorMessages.usuario.Correo;
    }
    if (!model.Correo2 || model.Correo2?.length == 0) {
      Errors.Correo2 = true;
      Mensajes.Correo2 = ErrorMessages.usuario.Correo;
    }
    if (!model.Celular || model.Celular?.length == 0) {
      Errors.Celular = true;
      Mensajes.Celular = ErrorMessages.usuario.Nombre;
    }
    if (!model.CodigoProveedor || model.CodigoProveedor?.length == 0) {
      Errors.CodigoProveedor = true;
      Mensajes.CodigoProveedor = ErrorMessages.usuario.CodigoProveedor;
    }
    if (model.Correo != model.Correo2) {
      Errors.Correo2 = true;
      Mensajes.Correo2 = ErrorMessages.usuario.CorreosDiferentes;
    }
    //Validar contraseña vs configuracion
    if (
      (model.Contraseña?.length ?? 0) < parseInt(longitudMinima?.valor) ||
      (model.Contraseña?.length ?? 0) > parseInt(longitudMaxima?.valor)
    ) {
      Errors.Contraseña = true;
      Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaLongitud.replace(
        "{0}",
        longitudMinima?.valor
      );
      Mensajes.Contraseña = Mensajes.Contraseña.replace(
        "{1}",
        longitudMaxima?.valor
      );
    }
    if (
      (model.Contraseña2?.length ?? 0) < parseInt(longitudMinima?.valor) ||
      (model.Contraseña2?.length ?? 0) > parseInt(longitudMaxima?.valor)
    ) {
      Errors.Contraseña2 = true;
      Mensajes.Contraseña2 = ErrorMessages.usuario.ContraseñaLongitud.replace(
        "{0}",
        longitudMinima?.valor
      );
      Mensajes.Contraseña2 = Mensajes.Contraseña.replace(
        "{1}",
        longitudMaxima?.valor
      );
    }
    if (
      requiereMayusculas?.valor === "True" &&
      !validateContieneMayusuculas(model.Contraseña) &&
      !Errors.Contraseña
    ) {
      Errors.Contraseña = true;
      Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaMayuscula;
    }
    if (
      requiereNumeros?.valor === "True" &&
      !validateContieneNumeros(model.Contraseña) &&
      !Errors.Contraseña
    ) {
      Errors.Contraseña = true;
      Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaNumero;
    }
    if (
      requiereCaracteresEspeciales?.valor === "True" &&
      !validateContieneCaracteresEspeciales(model.Contraseña) &&
      !Errors.Contraseña
    ) {
      Errors.Contraseña = true;
      Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaCaracter;
    }
    if (model.Contraseña != model.Contraseña2) {
      Errors.Contraseña2 = true;
      Mensajes.Contraseña2 = ErrorMessages.usuario.ContraseñasDiferentes;
    }
    if (!captcha.current.getValue()) {
      Errors.Captcha = true;
      Mensajes.Captcha = ErrorMessages.usuario.Captcha;
    }

    setErrors({ ...Errors });
    setMessages({ ...Mensajes });
    if (
      Errors.Nombre ||
      Errors.ApellidoPaterno ||
      Errors.ApellidoMaterno ||
      Errors.Correo ||
      Errors.Celular ||
      Errors.CodigoProveedor ||
      Errors.Contraseña ||
      Errors.Contraseña2
    )
      return false;
    return true;
  };

  const getParametersInitialForPasswordValidation = async () => {
    setLongitudMinima(
      await getParameter(EnumConfiguracion.Contrasenia_Longitud_Minima)
    );
    setLongitudMaxima(
      await getParameter(EnumConfiguracion.Contrasenia_Longitud_Maxima)
    );
    setRequiereNumeros(
      await getParameter(EnumConfiguracion.Contrasenia_Requiere_Numeros)
    );
    setRequiereMayusculas(
      await getParameter(EnumConfiguracion.Contrasenia_Requiere_Mayusculas)
    );
    setRequiereCaracteresEspeciales(
      await getParameter(
        EnumConfiguracion.Contrasenia_Requiere_Caracteres_Especiales
      )
    );
  };

  /** Servicios */
  /** */
  return (
    <Container className="mb-2">
      <LogisticBackdropStore />
      <Alerts />
      <Grid
        container
        direction={"column"}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item sx={{ textAlign: "center" }}>
          <Box display={"flex"} justifyContent={"center"}>
            <img src={logoLolify} alt="logo" width={"20%"} />
          </Box>
        </Grid>
        <Grid item sx={{ textAlign: "left", width: "100%" }}>
          <div
            style={{
              width: 100,
              cursor: "pointer",
              paddingTop: 10,
              paddingBottom: 10,
            }}
            onClick={() => {
              navigate("/");
            }}
          >
            <ArrowBackIcon fontSize="small" sx={{ display: "inline-block" }} />
            <Typography
              variant="h6"
              style={{ display: "inline-block", marginLeft: 5 }}
            >
              Regresar
            </Typography>
          </div>
        </Grid>
        <Grid item sm="6">
          <Card>
            <CardContent>
              <Typography color="primary" variant="h4" className="text-center">
                Registrarse
              </Typography>
              <Box component="form" noValidate>
                <Grid
                  container
                  rowSpacing={0}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item sm={6} xs={12}>
                    <TextField
                      size="small"
                      margin="normal"
                      required
                      fullWidth
                      id="name"
                      label="Nombre"
                      name="name"
                      autoFocus
                      inputProps={{ maxLength: 50 }}
                      error={errors.Nombre}
                      onChange={(e) => {
                        setValue("Nombre", e.target.value);
                        setError("Nombre", e.target.value.length <= 0);
                        setMessage(
                          "Nombre",
                          e.target.value.length <= 0
                            ? ErrorMessages.usuario.Nombre
                            : ""
                        );
                      }}
                      helperText={messages.Nombre}
                      value={model.Nombre || ""}
                    />
                  </Grid>
                  <Grid item sm={6} xs={6}>
                    <TextField
                      size="small"
                      margin="normal"
                      required
                      fullWidth
                      id="apellidoPaterno"
                      label="Apellido paterno"
                      name="apellidoPaterno"
                      inputProps={{ maxLength: 50 }}
                      error={errors.ApellidoPaterno}
                      onChange={(e) => {
                        setValue("ApellidoPaterno", e.target.value);
                        setError("ApellidoPaterno", e.target.value.length <= 0);
                        setMessage(
                          "ApellidoPaterno",
                          e.target.value.length <= 0
                            ? ErrorMessages.usuario.ApellidoPaterno
                            : ""
                        );
                      }}
                      helperText={messages.ApellidoPaterno}
                      value={model.ApellidoPaterno || ""}
                    />
                  </Grid>
                  <Grid item sm={6} xs={6}>
                    <TextField
                      size="small"
                      margin="normal"
                      required
                      fullWidth
                      id="apellidoMaterno"
                      label="Apellido materno"
                      name="apellidoMaterno"
                      inputProps={{ maxLength: 50 }}
                      error={errors.ApellidoMaterno}
                      onChange={(e) => {
                        setValue("ApellidoMaterno", e.target.value);
                        setError("ApellidoMaterno", e.target.value.length <= 0);
                        setMessage(
                          "ApellidoMaterno",
                          e.target.value.length <= 0
                            ? ErrorMessages.usuario.ApellidoMaterno
                            : ""
                        );
                      }}
                      helperText={messages.ApellidoMaterno}
                      value={model.ApellidoMaterno || ""}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      size="small"
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Correo electrónico"
                      name="email"
                      type="email"
                      autoComplete="off"
                      error={errors.Correo}
                      onChange={(e) => validationEmail("Correo", e)}
                      helperText={messages.Correo}
                      value={model.Correo || ""}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      onCopy={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      size="small"
                      margin="normal"
                      required
                      fullWidth
                      id="confirmEmail"
                      label="Confirma correo"
                      name="confirmEmail"
                      type="email"
                      autoComplete="off"
                      error={errors.Correo2}
                      onChange={(e) => validationEmail("Correo2", e)}
                      helperText={messages.Correo2}
                      value={model.Correo2 || ""}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      onCopy={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <InputMask
                      mask="999 999 99 99"
                      maskChar=" "
                      onChange={(e) => {
                        setValue("Celular", e.target.value.replace(/\s+/g, ""));
                        setError(
                          "Celular",
                          e.target.value.replace(/\s+/g, "").length < 10
                        );
                        setMessage(
                          "Celular",
                          e.target.value.replace(/\s+/g, "").length < 10
                            ? ErrorMessages.usuario.Celular
                            : ""
                        );
                      }}
                      value={model.Celular || ""}
                    >
                      {() => (
                        <TextField
                          size="small"
                          margin="normal"
                          required
                          fullWidth
                          id="phone"
                          label="Teléfono"
                          name="phone"
                          error={errors.Celular}
                          helperText={messages.Celular}
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      size="small"
                      margin="normal"
                      required
                      fullWidth
                      id="registerCode"
                      label="Código de registro"
                      name="registerCode"
                      autoComplete="off"
                      inputProps={{ maxLength: 8 }}
                      error={errors.CodigoProveedor}
                      onChange={(e) => {
                        setValue("CodigoProveedor", e.target.value);
                        setError("CodigoProveedor", e.target.value.length != 8);
                        setMessage(
                          "CodigoProveedor",
                          e.target.value.length != 8
                            ? ErrorMessages.usuario.CodigoProveedor
                            : ""
                        );
                      }}
                      helperText={messages.CodigoProveedor}
                      value={model.CodigoProveedor || ""}
                      onCopy={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      size="small"
                      type="password"
                      margin="normal"
                      required
                      fullWidth
                      id="password"
                      label="Contraseña"
                      name="password"
                      inputProps={{
                        maxLength: parseInt(longitudMaxima?.valor ?? 12),
                      }}
                      error={errors.Contraseña}
                      onChange={(e) => { validationContraseña("Contraseña", e.target.value) }}
                      helperText={messages.Contraseña}
                      value={model.Contraseña || ""}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      onCopy={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      size="small"
                      type="password"
                      margin="normal"
                      required
                      fullWidth
                      id="confirmPass"
                      label="Confirma contraseña"
                      name="confirmPass"
                      inputProps={{
                        maxLength: parseInt(longitudMaxima?.valor ?? 12),
                      }}
                      error={errors.Contraseña2}
                      onChange={(e) => { validationContraseña("Contraseña2", e.target.value) }}
                      helperText={messages.Contraseña2}
                      value={model.Contraseña2 || ""}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      onCopy={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <ReCAPTCHA
                      ref={captcha}
                      sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                      onChange={onChangeRecaptcha}
                    />
                    {errors.Captcha == true && (
                      <InputLabel sx={{ color: "#F12909" }}>{messages.Captcha}</InputLabel >
                    )}
                  </Grid>
                </Grid>
                <div className="mt-2 text-center">
                  <Button
                    onClick={() => setShowDialogClear(true)}
                    variant="contained"
                    color="secondary"
                    sx={{ color: "#fff" }}
                  >
                    Limpiar
                  </Button>
                  <Button
                    onClick={() => setShowDialogConfirmar(true)}
                    variant="contained"
                    sx={{ ml: 2 }}
                    disabled={disabledAceptar}
                  >
                    Aceptar
                  </Button>
                </div>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <DialogComponent
        Open={showDialogClear}
        Message="Se eliminará toda la información capturada. ¿Está seguro que desea continuar?"
        OnClose={() => setShowDialogClear(false)}
        OnAccept={() => {
          clearInitialState();
          setShowDialogClear(false);
        }}
      />
      <DialogComponent
        Open={showDialogConfirmar}
        Message="¿Todos los datos son correctos?"
        OnClose={() => setShowDialogConfirmar(false)}
        OnAccept={() => {
          guardarUsuario();
          setShowDialogConfirmar(false);
        }}
      />
    </Container>
  );
}

export default observer(RegisterPage);
